import { useEffect } from 'react'
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from './stores/auth'
import { Login } from './pages/Login'
import { Signup } from './pages/Signup'
import { Search } from './pages/Search'
import { Settings } from './pages/Settings'
import { Onboarding } from './pages/Onboarding'
import { Layout } from './components/Layout'

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  const loc = useLocation()
  if (loading) return <FullPage>Loading…</FullPage>
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />
  return <>{children}</>
}

function FullPage({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex items-center justify-center text-gray-400">
      {children}
    </div>
  )
}

export default function App() {
  const { refresh, user } = useAuth()
  const nav = useNavigate()
  const loc = useLocation()

  useEffect(() => {
    refresh()
  }, [refresh])

  // Redirect already-logged-in users away from auth pages.
  useEffect(() => {
    if (user && (loc.pathname === '/login' || loc.pathname === '/signup')) {
      nav('/', { replace: true })
    }
  }, [user, loc.pathname, nav])

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route
        path="/onboarding"
        element={
          <Protected>
            <Onboarding />
          </Protected>
        }
      />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route path="/" element={<Search />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
